var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentityTheftImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 88,
    viewBox: "0 0 280 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 88,
    rx: 6,
    fill: "#FEF3C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.043 45.101L153.65 41.819C153.349 41.7003 152.73 41.5453 152.028 41.819L143.631 45.101C142.844 45.4 142.333 46.1219 142.333 46.851C142.333 54.9885 147.346 60.6177 152.024 62.4479C152.726 62.7213 153.336 62.5664 153.646 62.4479C157.383 61.0552 163.333 55.9948 163.333 46.851C163.333 46.1219 162.823 45.4 162.043 45.101ZM152.833 59.05V45.2542L159.797 47.9798C159.389 54.3396 155.356 57.8541 152.833 59.05Z",
    fill: "#B45309"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M133 44.0002C138.155 44.0002 142.333 39.8213 142.333 34.6668C142.333 29.5124 138.155 25.3335 133 25.3335C127.845 25.3335 123.667 29.5124 123.667 34.6668C123.667 39.8213 127.845 44.0002 133 44.0002ZM140.044 47.9595C138.972 47.6679 137.856 47.5002 136.697 47.5002H129.303C122.326 47.5002 116.667 53.1658 116.667 60.1439C116.667 61.5366 117.798 62.6668 119.194 62.6668H146.803C147.032 62.6668 147.238 62.5936 147.449 62.5364C143.624 59.5897 140.299 54.522 140.044 47.9595Z",
    fill: "#B45309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityTheftImage);
export default __webpack_public_path__ + "static/media/identity-theft-image.4ba0967301b0f6424973469399ccb9bc.svg";
export { ForwardRef as ReactComponent };